import { render, staticRenderFns } from "./ModalAsignar.vue?vue&type=template&id=2f2b1ea3"
import script from "./ModalAsignar.vue?vue&type=script&lang=js"
export * from "./ModalAsignar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports